/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Box, Flex, Heading, Paragraph } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import Action from "./Action";
import CardContainer from "./CardContainer";

export const query = graphql`
  fragment CardItemFragment on ContentfulCardItem {
    image {
      gatsbyImageData
    }
    heading
    subHeading
    content {
      content
    }
    linkUrl
  }
`;

const CardItem = ({ gridItem, ...props }) => {
  const { content, heading, subHeading, image, linkUrl, imageAltText } = gridItem;
  return (
    <CardContainer {...props}>
      <Flex
        sx={{
          flexDirection: 'column',
          height: ['250px', '100%'],
        }}
        className="carditem"
        >
      <a sx={{color:"inherit"}} href={linkUrl}>
        <Box
          sx={{
            overflowY: 'hidden',
            height: ['140px', '248px'],
          }}>
          {image && (
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description || imageAltText}
              sx={{ height: '100%', width: '100%' }}
              imgStyle={{ 
                objectFit: 'cover'
              }}
            />
          )}
        </Box>
        <Box className="member-flag-style">
          <svg viewBox="223.433 137.109 144.264 29.532" xmlns="http://www.w3.org/2000/svg">
            <path d="M 296.242 146.403 L 223.433 137.109 L 223.433 166.641 L 367.697 166.641 L 367.697 137.282 L 296.242 146.403 Z" sx={{"fill": "rgb(255, 255, 255)"}}/>
          </svg>
        </Box>
        <Flex
          sx={{
            flexDirection: 'column',
            p: [3, 4],
            flex: '1 0 auto',
          }}
          className='card-item-content'>
          {heading && (
            <Heading
              as="h4"
              variant="bold"
              mb={[2, 3]}
              sx={{ fontSize: [3] }}
            >
              {heading}
            </Heading>
          )}
          {subHeading && (
            <Heading as="h4" mb={3} sx={{ fontSize: [2] }}>
              {subHeading}
            </Heading>
          )}
          {content &&
            <Paragraph mb={[3, 2]} sx={{ fontSize: [1] }}>
              {content.content || content}
            </Paragraph>
          }
        </Flex>
      </a>
        <Flex sx={{ justifyContent: "flex-end", pb: 4, px: 4 }} className='card-action'>
          <Action
            label="VIEW"
            style={{ styles: 'button primary' }}
            actionEvent="link"
            url={linkUrl}
          />
        </Flex>
      </Flex>
    </CardContainer>
  );
};

export default CardItem;
